import { I18nKeys } from './types';

export const MIN_COUNT = 1;

export const EMPTY_FILEDATA_ID = 'EMPTY_FILEDATA';

export const i18nKeys: Record<I18nKeys, string> = {
  FilePicker_ExploreFile: 'FilePicker_ExploreFile',
  FilePicker_RemoveFile: 'FilePicker_RemoveFile',
  FilePicker_AddNewFile: 'FilePicker_AddNewFile',
  FilePicker_ErrorMessage_Required: 'FilePicker_ErrorMessage_Required',
  FilePicker_ErrorMessage_ExtensionNotAllowed: 'FilePicker_ErrorMessage_ExtensionNotAllowed',
  FilePicker_ErrorMessage_ExtensionNotAllowed_WithAllowedExtensions: 'FilePicker_ErrorMessage_ExtensionNotAllowed_WithAllowedExtensions',
  FilePicker_Placeholder: 'FilePicker_Placeholder',
  FilePicker_ActionMessage_FileAdded: 'FilePicker_ActionMessage_FileAdded',
  FilePicker_ActionMessage_FileChanged: 'FilePicker_ActionMessage_FileChanged',
  FilePicker_ActionMessage_FileRemoved: 'FilePicker_ActionMessage_FileRemoved',
};
